import React from "react"
import Navigation from "../navigation"
import styles from "./cmmcheader.module.css"
import header from "./CMMC_1021.png"

const CMMCHeader = (props) => {

    return (
        <div className={styles.container}>
            <Navigation 
                type="horizontal"
                items={[
                    {
                        title: "Upcoming Sessions",
                        url: "/#events",
                    },
                    {
                        title: "On-Demand Sessions",
                        url: "/on-demand",
                    },
                    
                    
                ]}
            />
            <img src={header} alt="SNG Live CMMC" className="deskHead" width="100%"/>
            <img src={header} alt="SNG Live CMMC" className="mobHead" width="100%"/>
            <div className={styles.hideme}>
                <h1 className={styles.title}>{props.title}</h1>
                <h1 className={styles.subTitle}>{props.subTitle}</h1>
                
            </div>
            
        </div>
    )
}

CMMCHeader.defaultProps = {
    title: `SNG Live - CMMC`,
    subTitle: `2020`
}
export default CMMCHeader